const debugKey = 'debug';

const isDebugMode = !!window.location.search
  .substring(1)
  .toLowerCase()
  .split('&')
  .filter((param) => param.split('=')[0] === debugKey)
  .map((param) => param.split('=')[1])[0];

if (isDebugMode) {
  window.isDebugMode = isDebugMode;
  console.log('Debug mode enabled.'); // eslint-disable-line no-console
}

export default isDebugMode;
